export default __webpack_public_path__ + "static/media/1252.1489fb08.png";